"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _defineProperty2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _zhjySerach = _interopRequireDefault(require("@/components/search/zhjySerach.vue"));
var _funBtn = _interopRequireDefault(require("@/components/funBtn/funBtn.vue"));
var _zhjyTable = _interopRequireDefault(require("@/components/table/zhjyTable.vue"));
var _zhjyPagination = _interopRequireDefault(require("@/components/zhjyPagination/zhjyPagination.vue"));
var _user = require("@/api/admin/user/user");
var _index = require("@/api/draw/index");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      typeConfigParam: {},
      typeList: [{
        keyData: "文件类型",
        valueData: 1
      }, {
        keyData: "作品项类型",
        valueData: 2
      }, {
        keyData: "院校类型",
        valueData: 3
      }, {
        keyData: "承诺书Url",
        valueData: 4
      }, {
        keyData: "学校导入模板地址",
        valueData: 5
      }, {
        keyData: "抽签开始时间",
        valueData: 6
      }, {
        keyData: "抽签结束时间",
        valueData: 7
      }],
      dialogShow: false,
      funBtns: [{
        size: "small",
        click: "add",
        icon: "el-icon-delete",
        name: "新增",
        type: "danger"
      }],
      options: [{
        name: "编辑",
        class: "editor",
        option: "editLogo",
        span: 3
      }, {
        name: "删除",
        class: "editor",
        option: "delete",
        span: 3
      }],
      queryGroup: [{
        label: "精确查找",
        type: "input",
        model: "queryValue",
        placeholder: "名称"
      }],
      modelData: {
        queryValue: ""
      },
      defaultColumn: [{
        name: "名称",
        prop: "keyData",
        isShow: true,
        width: "100"
      }, {
        name: "值",
        prop: "valueData",
        isShow: true,
        width: "100"
      }, {
        name: "类型",
        prop: "businessType",
        isShow: true,
        width: "150",
        isFormats: true
      }],
      minWidth: 300,
      page: {
        pageNumber: 1,
        pageSize: 10
      },
      isDisabled: false,
      totalData: 0,
      listData: [],
      formatters: {
        businessType: [{
          name: "文件类型",
          value: "1"
        }, {
          name: "作品项类型",
          value: "2"
        }, {
          name: "院校类型",
          value: "3"
        }, {
          name: "承诺书Url",
          value: "4"
        }, {
          name: "学校导入模板地址",
          value: "5"
        }, {
          name: "抽签开始时间",
          value: "6"
        }, {
          name: "抽签结束时间",
          value: "7"
        }]
      },
      sort: {
        prop: "",
        order: ""
      },
      name: "",
      checkBoxs: [],
      dialogTitle: ""
    };
  },
  methods: (0, _defineProperty2.default)((0, _defineProperty2.default)({
    //新增
    add: function add() {
      this.typeConfigParam = {};
      this.dialogShow = true;
    },
    //删除
    deleteConfig: function deleteConfig(row) {
      var _this = this;
      (0, _index.deleteConfig)({
        id: row.id
      }).then(function (res) {
        if (res.code == 2000) {
          _this.$message.success(res.msg);
          _this.getConfigsList();
        } else {
          _this.$message.error(res.msg);
        }
      });
    },
    //获取列表
    getConfigsList: function getConfigsList() {
      var _this2 = this;
      (0, _index.getConfigsList)({
        businessTypeId: "",
        BusinessId: this.$route.query.businessId
      }).then(function (res) {
        if (res.code == 2000) {
          _this2.listData = res.data;
        }
      });
    },
    // 搜索框
    search: function search(v) {
      this.name = v.queryValue;
      this.getConfigsList();
    },
    //取消
    handleReset: function handleReset() {
      this.dialogShow = false;
      this.typeConfigParam = {};
    },
    handleSubmit: function handleSubmit() {
      var _this3 = this;
      if (this.typeConfigParam.id == undefined || this.typeConfigParam.id == "") {
        (0, _index.insertConfig)(_objectSpread(_objectSpread({}, this.typeConfigParam), {}, {
          businessId: this.$route.query.businessId
        })).then(function (res) {
          _this3.dialogShow = false;
          if (res.code == 2000) {
            _this3.$message.success(res.msg);
            _this3.getConfigsList();
          } else {
            _this3.$message.error(res.msg);
          }
        });
      } else {
        (0, _index.updateConfig)({
          id: this.typeConfigParam.id,
          valueData: this.typeConfigParam.valueData
        }).then(function (res) {
          _this3.dialogShow = false;
          if (res.code == 2000) {
            _this3.$message.success(res.msg);
            _this3.getConfigsList();
          } else {
            _this3.$message.error(res.msg);
          }
        });
      }
    },
    // 编辑按钮操作
    editLogo: function editLogo(row) {
      var _this4 = this;
      this.isDisabled = true;
      (0, _index.getConfig)({
        id: row.id
      }).then(function (res) {
        if (res.code == 2000) {
          _this4.typeConfigParam = res.data;
          _this4.dialogTitle = "编辑";
          _this4.dialogShow = true;
        } else {
          _this4.$message.error(res.msg);
        }
      });
    }
  }, "add", function add() {
    this.dialogShow = true;
    this.isDisabled = false;
    this.dialogTitle = "新增";
    this.typeConfigParam = {};
  }), "handleSelectionChange", function handleSelectionChange(row) {
    var _this5 = this;
    this.checkBoxs = [];
    row.forEach(function (item) {
      _this5.checkBoxs.push(item.id);
    });
  }),
  components: {
    ZhjySerach: _zhjySerach.default,
    ZhjyPagination: _zhjyPagination.default,
    FunBtn: _funBtn.default,
    ZhjyTable: _zhjyTable.default
  },
  created: function created() {
    //查看全部配置项
    this.getConfigsList();
  }
};